module.exports = __webpack_public_path__ + "img/elementos_termicos.0aef929c.jpg";